<amplify-authenticator [hideSignUp]="true">
  <ng-template amplifySlot="sign-in">
    <div class="inner">
      <div class="auth-buttons">
        <div style="padding: var(--amplify-space-large); text-align: center">
          <h3
            class="amplify-heading"
            style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl)"
          ></h3>
          <br />
          <svg
            viewBox="19 284.2 761.4 163.88"
            width="250"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m19 284.82h158.88v159.8h-108.07s-42.03-.46-50.81-47.11z"
              fill="#fd0"
            />
            <g fill="#1b2d54">
              <path
                d="m98.44 312.99h53.58v51.73h-24.02v-29.1h-29.56zm171.35-25.86c13.39 2.31 13.39 16.17 13.39 16.17 1.85 7.39-6.93 15.24-6.93 15.24 8.78 2.31 8.78 14.78 8.78 14.78.92 16.17-17.55 18.94-17.55 18.94h-36.95v-65.12h39.26zm-25.4 11.54v14.32h19.4s6.77-1.54 6.47-7.16c0 0-.62-7.16-7.08-7.16zm0 24.94v16.63h18.78s8.62-1.08 9.24-9.01c0 0-.31-7.62-8.01-7.62zm71.74-36.48h13.86l25.56 65.12h-14.16l-5.23-13.39h-25.26l-6.16 13.39h-13.86zm7.08 18.7-9.24 21.79h18.47zm417.77 72.21h13.86l25.56 65.12h-14.17l-5.23-13.39h-25.25l-6.16 13.39h-13.86zm7.09 18.71-9.24 21.79h18.47zm-257.35-64.82 8.31 8.31s-7.39 12.01-26.48 12.01c0 0-33.25 4.46-36.03-32.56 0 0-2.16-33.33 36.03-34.87 0 0 16.63-.62 24.94 11.08l-9.24 8.62s-4.85-7.24-16.86-7.24c0 0-18.71-.3-20.09 21.33 0 0-.92 20.47 20.55 22.09.01 0 12.79.93 18.87-8.77zm-114.25 91.37 8.31 8.31s-7.39 12.01-26.48 12.01c0 0-33.25 4.46-36.03-32.56 0 0-2.16-33.33 36.03-34.87 0 0 16.63-.62 24.94 11.08l-9.24 8.63s-4.85-7.24-16.86-7.24c0 0-18.71-.3-20.09 21.33 0 0-.92 20.47 20.55 22.09.01 0 12.79.92 18.87-8.78zm250.51 0 8.31 8.31s-7.39 12.01-26.48 12.01c0 0-33.25 4.46-36.03-32.56 0 0-2.15-33.33 36.03-34.87 0 0 16.63-.62 24.94 11.08l-9.24 8.62s-4.85-7.24-16.86-7.24c0 0-18.71-.3-20.09 21.33 0 0-.92 20.47 20.55 22.09.01.01 12.79.93 18.87-8.77zm-86.29-82.51c-11.99 0-21.71-9.72-21.71-21.71s9.72-21.71 21.71-21.71 21.71 9.72 21.71 21.71-9.72 21.71-21.71 21.71zm34.65-21.7c0-19.14-15.51-34.65-34.65-34.65s-34.65 15.51-34.65 34.65 15.51 34.65 34.65 34.65 34.65-15.52 34.65-34.65zm-103.71 58.33h12.7v66.37h-12.7zm-175.51 0h12.7v66.37h-12.7zm-64.66 66.37v-66.37h33.25s19.63 2.54 18.71 22.17c0 0 1.62 17.09-18.24 21.94h-20.78v22.26zm12.93-53.9v20.1h16.4s9.49-1.85 9.48-10.05c0 0 .68-9.59-8.32-10.05zm153.34-12.47v66.37h13.16v-27.58h29.33v27.58h12.7v-66.37h-8.54s-4.16.23-4.16 4.62v20.78h-29.79v-25.4zm251.25 0v66.37h13.16v-27.58h29.33v27.58h12.7v-66.37h-8.54s-4.16.23-4.16 4.62v20.78h-29.79v-25.4zm-282.89-25.17v-65.12h15.01s3 .69 4.62 3.7l24.94 41.11v-44.8h12.7v65.12h-13.39s-2.31.23-4.39-3.23l-25.17-41.34v44.57h-14.32zm136.11 91.54v-65.12h15.01s3 .69 4.62 3.69l24.94 41.11v-44.8h12.7v65.12h-13.39s-2.31.23-4.39-3.23l-25.17-41.34v44.57z"
              />
              <text
                font-family="'RobotoSlab-Regular'"
                font-size="37.34"
                transform="translate(226.838 510.207)"
              >
                En confianza.
              </text>
            </g>
          </svg>
          <br />
          <br />
          <br />
          <pichincha-typography
            variant="prelo-slab"
            color="bp-primary-blue500"
            weight="900"
            size="18px"
            lineHeight="15px"
            spacing="1"
            category="h1"
            tabIndexElement="2"
            align="center"
          >
            Ingreso Consulta Grabaciones Históricas Genesys
          </pichincha-typography>
          <br />
          <div class="ex-button-row"></div>
          <br *ngIf="showSessionAlert" />
          <pichincha-button
            variant="primary"
            label="Iniciar sesion con Azure ADFS"
            (click)="handleSignInClick()"
          ></pichincha-button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Optionally, you can also hide the SignUp and Forgot Password screens -->
  <ng-template amplifySlot="sign-up">
    <div class="auth-buttons">
      <pichincha-button
        variant="primary"
        label="Iniciar sesion con Azure ADFS"
        (click)="handleSignInClick()"
      ></pichincha-button>
    </div>
  </ng-template>

   <mat-sidenav-container fullscreen>
    <mat-toolbar color="primary">
      <a mat-button (click)="salga()">
        <mat-icon>account_circle</mat-icon>
        <pichincha-typography
          variant="prelo"
          color="bp-grayScaleWhite"
          weight="200"
          size="12px"
          lineHeight="20px"
          spacing="1"
          category="text"
          tabIndexElement="2"
          align="center"
        >
          Salir
        </pichincha-typography>
      </a>
      <div class="sidebar-content"></div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-container>
</amplify-authenticator>
